/* eslint-disable react-hooks/rules-of-hooks */
import React, { FC, useMemo } from "react";
import { RangeValue } from "@evergis/ui";

import { OptionChip, OptionText } from "../../styled";
import { getSafetyScale, prettifyScale, scaleIsDefault } from "../../../../evergis/core/scale";
import { useLayerConditionCount } from "../../../../hooks/layer/useLayerConditionCount";
import { useDefaultScaleRange } from "../../../../hooks/style/useDefaultScaleRange";
import { LayerItemMenuOption, ListItemValue } from "./types";
import { LayerInfo, TableInfo } from "../../../../interfaces/resourceInfo";

type OptionRenderProps = {
  item: LayerItemMenuOption;
  layer: LayerInfo;
  table: TableInfo;
  defaultScaleRange?: RangeValue;
};

const MenuOptionRenderMap: Partial<Record<ListItemValue, FC<OptionRenderProps>>> = {
  layerFilter: ({ item, layer }) => {
    const layerConditionsCount = useLayerConditionCount(layer);

    return (
      <OptionText>
        <span>{item.text}</span>
        {layer.condition && <OptionChip primary text={layerConditionsCount} />}
      </OptionText>
    );
  },
  scaleRestriction: ({ item, layer, defaultScaleRange }) => {
    const scaleRange = useMemo(
      () =>
        !scaleIsDefault(layer.style, defaultScaleRange) &&
        prettifyScale(getSafetyScale(layer.style, defaultScaleRange)),
      [defaultScaleRange, layer.style],
    );

    return (
      <OptionText>
        <span>{item.text}</span>
        {scaleRange && <OptionChip primary text={scaleRange} />}
      </OptionText>
    );
  },
};

export const MenuOptionRender: FC<OptionRenderProps> = ({ item, layer, table }) => {
  const defaultScaleRange = useDefaultScaleRange();
  const Renderer = MenuOptionRenderMap[item && item.value] as FC<OptionRenderProps>;

  return Renderer ? (
    <Renderer item={item} layer={layer} table={table} defaultScaleRange={defaultScaleRange} />
  ) : (
    (item.text as unknown as React.ReactElement)
  );
};
